import { socialLinks } from "../data"
const SocialLink = ({ itemClass, href, icon,text }) => {
  return (
    <ul>
      <a href={href} text={text} target='_blank' rel='noreferrer' className={itemClass}>
        {text}
      </a>
    </ul>
  )
}
export default SocialLink
